import { render } from "./donateModal.vue?vue&type=template&id=2dda8f11&scoped=true"
import script from "./donateModal.vue?vue&type=script&lang=js"
export * from "./donateModal.vue?vue&type=script&lang=js"

import "./donateModal.vue?vue&type=style&index=0&id=2dda8f11&scoped=true&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dda8f11"]])

export default __exports__